import { Helmet } from "react-helmet-async";

const SITE_NAME = "NERO SUN";
const DEFAULT_DESC =
  "NERO SUN — the digital magazine charting the global convergence of hip-hop and everything it touches: music, fashion, athletes, cars, food, business, media and more.";
const DEFAULT_IMAGE =
  "https://images.unsplash.com/photo-1483985988355-763728e1935b?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200";

/**
 * Per-page SEO: unique title, meta description, canonical + Open Graph / Twitter cards.
 * Keeps each page distinct for Google and social previews.
 */
export function Seo({ title, description, image, type = "website", path, noindex = false }) {
  const fullTitle = title ? `${title} — ${SITE_NAME}` : `${SITE_NAME} — Where Hip-Hop & Everything Converges`;
  const desc = (description || DEFAULT_DESC).slice(0, 300);
  const img = image || DEFAULT_IMAGE;
  const url =
    typeof window !== "undefined"
      ? `${window.location.origin}${path || window.location.pathname}`
      : path || "";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {noindex && <meta name="robots" content="noindex" />}
      <meta name="description" content={desc} />
      {url && <link rel="canonical" href={url} />}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      {url && <meta property="og:url" content={url} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
